<template lang="pug">
	.auth(:class="state")
		.logo
			.img-publisher(v-if="User.invitationDetails" :style="{background: `url(/Images/Icons/Publishers/${User.invitationDetails.publisherCodename || User.invitationDetails.publisherId}.png) center / contain no-repeat`}")
			.img
		.auth-forms(v-if="Metadata.loaded && Publisher.loaded")
			.login-area
				.login-content
					.title Login
					.description(v-if="!User.invitationDetails") Sign in to your company account if you already have access to {{Metadata.Config['dashboard-page-title'] || ''}}
					.description(v-if="User.invitationDetails") Hi, {{User.invitationDetails.userName}}! Please sign in to accept invitation to the {{User.invitationDetails.publisherTitle}} account.
					//- Причина неудачного входа: например аккаунт заведён на ноде, которая сейчас недоступна
					.login-error(v-if="Auth.loginError") {{Auth.loginError}}
					.buttons
						img.google-login(v-on:click="openGoogleLogin()" src="../../../public/Images/Screens/Login/sign-in-with-google.png")
						img.linked-in-login(v-on:click="openLinkedInLogin()" src="../../../public/Images/Screens/Login/sign-in-with-linkedin.png")
					//- Локальный вход вынесен на отдельную строку: по нажатию открывается список
					//- тестовых пользователей всех онлайн-нод кластера (нода, имя, роль) - см. Documents/Cluster.txt
					.dev-login-area(v-if="Metadata.Config['dev-login-url']")
						button.btn.btn-outline-light.dev-login(type="button" v-on:click="toggleDevUsers()") Sign in as developer
						.dev-login-users(v-if="devUsersOpened")
							.dev-login-empty(v-if="!Auth.devUsers.length") No users available
							.dev-login-server(v-for="server in getDevUserServers()" :key="server.serverId")
								.dev-login-server-title {{server.title}}
								button.dev-login-user(type="button" v-for="user in server.users" :key="server.serverId + '-' + user.userId" v-on:click="openDevLogin(user)")
									span.dev-login-user-name {{user.name}}
									span.dev-login-user-role {{user.roles.length ? user.roles.join(', ') : 'user'}}
									span.dev-login-user-publisher(v-if="user.publisherTitle") {{user.publisherTitle}}
			.signup-area
				.signup-content
					.back-right(v-on:click="state = ''")
						.fa.fa-angle-double-right
					.back-left(v-on:click="state = ''")
						.fa.fa-angle-double-left
					.title Sign Up
					.description Create a new company account and try demo playables for free
					.controls
						.sign-up-controls.start-sign-up
							button.btn.btn-lg.btn-outline-light(v-on:click="state = 'sign-up'") Create a company account
						.sign-up-controls.end-sign-up
							.input-group.mb-3
								.input-group-prepend
									span.input-group-text
										.icon.fa.fa-building
								input.form-control(type="text" placeholder="Company name" v-model="companyName")
							.buttons(:style="{pointerEvents: _.kebabCase(companyName).length >= 2 ? 'auto' : 'none', opacity: _.kebabCase(companyName).length >= 2 ? '1' : '0.2'}")
								img.google-login(v-on:click="openGoogleSignUp()" src="../../../public/Images/Screens/Login/sign-up-with-google.png")
								img.linked-in-login(v-on:click="openLinkedInSignUp()" src="../../../public/Images/Screens/Login/sign-up-with-linkedin.png")
</template>

<script>
	import Screen 							from './../../mixins/screen'
	import { Metadata } 					from './../../services/Metadata'
	import { Publisher } 					from './../../services/Publisher'
	import { User } 						from './../../services/User'
	import { Auth } 						from './../../services/Auth'
	import { Server } 						from './../../services/Server'

	export default {
		name: 'Auth',
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed", "Metadata Loaded", "Publishers Exists Changed", "Invitation Details Changed", "Dev Users Received"]
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;
			this.Auth = Auth;

			return {
				showed: true,
				state: '',
				companyName: '',
				// Открыт ли список пользователей для локального входа
				devUsersOpened: false
			}

		},
		methods: {
			collectData() {

				if (Metadata.Config['feature-single-publisher'] && Publisher.isPublisherExists) this.state = 'auth-only';
				if (Layout.invitationRequested) this.state = 'invitation';

			},
			// Локальный вход без Google/LinkedIn: список пользователей собирается с нод кластера,
			// которые сейчас на связи (кнопка показывается только в режиме разработки)
			toggleDevUsers() {

				this.devUsersOpened = !this.devUsersOpened;

				this.$forceUpdate();

				// Список запрашиваем у ноды аккаунта (первичного соединения): запросы клиента по умолчанию
				// уходят на ноду выбранного ранее паблишера, а её соединение авторизовано - нода пропустила бы
				// действие, доступное неавторизованным, и список остался бы пустым
				if (this.devUsersOpened) Server.sendToServer({GetDevUsers: {}}, Server.getPrimaryServerId());

			},
			// Пользователи для локального входа, сгруппированные по нодам кластера
			getDevUserServers() {

				let servers = [];

				_.each(Auth.devUsers, user => {

					let server = _.find(servers, server => server.serverId === user.serverId);

					if (!server) servers.push(server = {serverId: user.serverId, title: user.serverTitle, users: []});

					server.users.push(user);

				});

				return _.sortBy(servers, 'serverId');

			},
			// Вход под тестовым пользователем: клиент подключится к ноде, на которой заведён его аккаунт
			openDevLogin(user) {

				document.location = Metadata.Config['dev-login-url'] + `?server=${user.serverId}&id=${user.userId}`;

			},
			openLinkedInLogin() {

				document.location = Metadata.Config['linkedin-login-url'] + (User.invitationDetails ? `?acceptInvitation=${Layout.invitationRequested}` : '');

			},
			openGoogleLogin() {

				document.location = Metadata.Config['google-login-url'] + (User.invitationDetails ? `?acceptInvitation=${Layout.invitationRequested}` : '');

			},
			openLinkedInSignUp() {

				document.location = Metadata.Config['linkedin-login-url'] + '?createCompanyAccount=' + encodeURIComponent(this.companyName);

			},
			openGoogleSignUp() {

				document.location = Metadata.Config['google-login-url'] + '?createCompanyAccount=' + encodeURIComponent(this.companyName);

			}
		}
	}
</script>

<style lang="sass" scoped>

	.auth
		display: flex
		flex-direction: column
		justify-content: center
		align-items: center
		background: center top / 100% auto no-repeat fixed
		background-size: cover
		min-height: 100vh

		.logo
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center
			height: 13vh
			width: 100%
			padding: 20px
			padding-bottom: 0

			.img
				height: 60%
				width: 90%
				background: url("../../../public/Images/Screens/Login/dashboard-logo.png") center / contain no-repeat
				image-rendering: -webkit-optimize-contrast

			.img-publisher
				margin-bottom: 15px
				height: 40%
				width: 90%
				image-rendering: -webkit-optimize-contrast

		.auth-forms
			display: flex
			flex-direction: row
			align-items: center
			justify-content: center
			width: 90vw
			max-width: 850px
			background-color: #24252f
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
			border-radius: 0.25rem
			margin: 20px
			overflow: hidden
			font-size: 0
			height: 260px
			transition: width 0.5s ease-in-out, max-width 0.5s ease-in-out

			.login-area
				width: 50%
				height: 100%
				color: rgba(255, 255, 255, 0.87)
				text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.27)
				font-weight: normal
				transition: width 0.5s ease-in-out, height 0.5s ease-in-out

				.login-content
					margin: 2.75rem
					width: 45vw
					max-width: calc(850px / 2 - 2.75rem * 2)

					.title
						font-size: 2.1875rem

					.description
						color: rgba(255, 255, 255, 0.6)
						font-size: 0.875rem

					.login-error
						margin-top: 0.5rem
						color: #ff9c9c
						font-size: 0.8125rem

					.buttons
						display: flex
						flex-direction: row
						align-items: center
						justify-content: left
						margin-top: 1rem

						.linked-in-login
							display: flex
							height: 34px
							background-size: contain
							cursor: pointer
							filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))
							margin-left: 10px
							image-rendering: -webkit-optimize-contrast

						.google-login
							display: flex
							height: 34px
							cursor: pointer
							filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))
							image-rendering: -webkit-optimize-contrast

					// Локальный вход: кнопка на отдельной строке, под ней - список тестовых пользователей нод.
					// Список позиционируем fixed: у формы авторизации задан overflow hidden.
					.dev-login-area
						margin-top: 1rem

						.dev-login
							font-size: 0.8125rem
							padding: 0.25rem 0.75rem

						.dev-login-users
							position: fixed
							z-index: 10
							width: auto
							max-height: 220px
							margin-top: 0.25rem
							overflow-y: auto
							overflow-x: hidden
							background-color: #1c1d25
							border: 1px solid rgba(255, 255, 255, 0.1)
							border-radius: 0.25rem
							box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5)
							padding: 0.5rem

							.dev-login-empty
								color: rgba(255, 255, 255, 0.6)
								font-size: 0.8125rem

							.dev-login-server
								&:not(:first-child)
									margin-top: 0.5rem

								.dev-login-server-title
									font-size: 0.6875rem
									text-transform: uppercase
									letter-spacing: 0.05em
									color: rgba(255, 255, 255, 0.55)
									margin-bottom: 0.25rem

								.dev-login-user
									display: flex
									flex-direction: row
									align-items: baseline
									width: 100%
									text-align: left
									background: none
									border: none
									padding: 0.25rem 0.5rem
									border-radius: 0.25rem
									color: rgba(255, 255, 255, 0.87)
									font-size: 0.8125rem
									cursor: pointer

									&:hover
										background-color: rgba(255, 255, 255, 0.1)

									.dev-login-user-name
										font-weight: 600

									.dev-login-user-role
										margin-left: 0.5rem
										color: rgba(255, 255, 255, 0.6)

									.dev-login-user-publisher
										margin-left: 0.5rem
										color: rgba(255, 255, 255, 0.45)

			.signup-area
				width: 50%
				height: 100%
				background-color: var(--green)
				padding: 2.75rem
				color: rgba(255, 255, 255, 0.87)
				text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.27)
				font-weight: normal
				position: relative
				transition: width 0.5s ease-in-out

				.signup-content
					width: 45vw
					max-width: calc(850px / 2 - 2.75rem * 2)

					.back-right
						display: none
						font-size: 0.875rem
						width: 30px
						height: 30px
						position: absolute
						right: 10px
						top: 10px
						align-items: center
						justify-content: center
						opacity: 0
						transition: opacity 0.2s ease-in-out

					.back-left
						font-size: 0.875rem
						width: 30px
						height: 30px
						position: absolute
						left: 10px
						top: 10px
						display: flex
						align-items: center
						justify-content: center
						opacity: 0
						transition: opacity 0.2s ease-in-out

					.title
						font-size: 2.1875rem

					.description
						color: rgba(255, 255, 255, 1)
						font-size: 0.875rem

					.controls
						position: relative
						width: 99%
						height: 220px
						margin-top: 1rem

						.sign-up-controls
							position: absolute
							left: 0
							top: 0
							width: 100%
							transition: opacity 0.5s ease-in-out

						.end-sign-up
							opacity: 0
							pointer-events: none

							.buttons
								display: flex
								flex-direction: row
								align-items: center
								justify-content: left
								margin-top: 1rem
								transition: opacity 0.2s ease-in-out

								.linked-in-login
									display: flex
									height: 35px
									background-size: contain
									cursor: pointer
									filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))
									margin-left: 10px

								.google-login
									display: flex
									height: 35px
									cursor: pointer
									filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))

	.auth.sign-up

		.auth-forms
			max-width: 550px

			.login-area
				width: 0
				padding: 0

			.signup-area
				width: 100%

				.back-left
					opacity: 1
					cursor: pointer

				.controls

					.start-sign-up
						opacity: 0
						pointer-events: none

					.end-sign-up
						opacity: 1
						pointer-events: auto

	.auth.auth-only

		.auth-forms
			max-width: 450px
			transition: none

			.login-area
				width: 100%
				transition: none

			.signup-area
				display: none

	.auth.invitation

		.auth-forms
			max-width: 450px
			transition: none

			.login-area
				width: 100%
				transition: none

			.signup-area
				display: none

	@media screen and (max-width: 800px)

		.auth

			.auth-forms
				flex-direction: column
				height: auto
				align-items: flex-start

				.login-area
					width: 100%
					height: 300px

					.login-content
						width: calc(90vw - 2.75rem * 2)
						max-width: calc(90vw - 2.75rem * 2)

						.buttons
							flex-direction: column
							align-items: flex-start

							.linked-in-login
								margin-left: 0
								margin-top: 10px

				.signup-area
					width: 100%
					height: auto

					.signup-content
						width: 100%

		.auth.sign-up

			.auth-forms

				.login-area
					padding: 0
					height: 0

				.signup-area
					width: 100%

					.back-left
						opacity: 1
						cursor: pointer

					.sign-up-controls.end-sign-up

						input.form-control
							border-color: hsla(0,0%,100%,.5) !important

</style>
